import { PopularSearchAutoSuggestionResponse, PopularSearchResponse } from '@modules/libs/graphql/generated/graphql';
import { ISearchTag } from '@modules/search/domain/models/searchTag.model';
import { ISuggestSearch } from '@modules/search/domain/models/suggestSearch.model';
export class SuggestSearchEntityMapper {
  public static toDomain(searchResultResponse: PopularSearchAutoSuggestionResponse): ISuggestSearch {
    const {
      products,
      recipes,
      tipsTricks
    } = searchResultResponse;
    return {
      products: this.mapSuggestSearchItems(products, 'product'),
      recipe: this.mapSuggestSearchItems(recipes, 'recipe'),
      tipsTricks: this.mapSuggestSearchItems(tipsTricks, 'tips-tricks')
    };
  }
  private static mapSuggestSearchItems(data: PopularSearchResponse[], module: 'product' | 'recipe' | 'tips-tricks'): ISearchTag[] {
    return data.map(item => {
      return {
        id: item.id,
        text: item.title,
        linkOut: `/${module}/${item.slugUrl}`
      };
    });
  }
}